import { FC } from "react";

import Typography from "@mui/material/Typography";
import Box, { BoxProps } from "@mui/material/Box";
import Container from "@mui/material/Container";
import { useMediaQuery, useTheme } from "@mui/material";

import Heading from "sections/nfcTagsPage/Heading";

import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";

import styles from "./styles";

export interface Metric {
  value: string;
  label: string;
  imageUrl: string;
}

interface KeyMetricsSectionProps {
  heading?: string;
  metrics: Metric[];
  boxProps?: BoxProps;
}

const KeyMetricsSection: FC<KeyMetricsSectionProps> = ({ 
  heading = "KEY RESULTS & OUTCOME",
  metrics,
  boxProps 
}) => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));

  return (
    <Box component="section" {...boxProps}>
      <Container>
        <Heading heading={heading} />

        <GridContainer spacing={0}>
          {metrics.map((metric, i) => (
            <GridItem
              xs={12}
              md={6}
              lg={3}
              key={`${i}-metric`}
              rowSpacing={4}
              sx={styles.itemWrapper}
            >
              <Box position="relative">
                <Box sx={(theme) => styles.box(theme, metric.imageUrl)}>
                  <Typography variant="h1" component="div" sx={styles.value}>
                    {metric.value}
                  </Typography>
                  <Typography variant="h4" component="div" sx={styles.label}>
                    {metric.label}
                  </Typography>
                </Box>
              </Box>
            </GridItem>
          ))}
        </GridContainer>
      </Container>
    </Box>
  );
};

export default KeyMetricsSection;

